import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import Article from "../components/articles/article";
import AboutBuilder from "../components/common/aboutBuilder";

import INFO from "../data/user";
import SEO from "../data/seo";
import myArticles, { TOPICS } from "../data/articles";

import "./styles/articles.css";
import "./styles/tools.css";

// A few real terms that return hits, shown under the search box so readers
// know what is worth typing.
const SUGGESTED = [
	"NIST",
	"prompt injection",
	"mentorship",
	"imposter syndrome",
	"accountability",
	"Claude Code",
];

const Articles = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "articles");

	const [topic, setTopic] = useState("All");
	const [query, setQuery] = useState("");

	const q = query.trim().toLowerCase();
	const filtered = myArticles.filter((a) => {
		if (topic !== "All" && a.topic !== topic) return false;
		if (!q) return true;
		const haystack = [a.title, a.tldr, a.description, ...(a.keywords || [])]
			.join(" ")
			.toLowerCase();
		return haystack.includes(q);
	});

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Articles | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="articles" />
				<div className="content-wrapper">
					<div className="articles-logo-container">
						<div className="articles-logo">
							<Logo width={46} />
						</div>
					</div>

					<div className="articles-main-container">
						<div className="title articles-title">
							{INFO.articles.title}
						</div>

						<div className="subtitle articles-subtitle">
							{INFO.articles.description}
						</div>

						<div className="articles-banner">
							New here? Start with the guided path,{" "}
							<Link to="/path">
								AI Governance for FinServ Leaders
							</Link>
							, or try the{" "}
							<Link to="/tools">interactive tools</Link>.
						</div>

						<div className="articles-filter">
							{["All", ...TOPICS].map((t) => (
								<button
									key={t}
									className={`articles-chip${
										topic === t ? " active" : ""
									}`}
									onClick={() => setTopic(t)}
								>
									{t}
								</button>
							))}
						</div>

						<div className="articles-search">
							<input
								type="text"
								placeholder="Search articles..."
								value={query}
								onChange={(e) => setQuery(e.target.value)}
								aria-label="Search articles"
							/>
							<div className="articles-suggest">
								<span className="articles-suggest-label">
									Try:
								</span>
								{SUGGESTED.map((k) => (
									<button
										key={k}
										className="articles-suggest-term"
										onClick={() => setQuery(k)}
									>
										{k}
									</button>
								))}
							</div>
						</div>

						<div className="articles-container">
							<div className="articles-wrapper">
								{filtered.length === 0 && (
									<div className="articles-empty">
										No articles match that filter yet.
									</div>
								)}
								{filtered.map((article) => (
									<div
										className="articles-article"
										key={article.slug}
									>
										<Article
											key={article.slug}
											date={article.date}
											title={article.title}
											description={article.tldr || article.description}
											readingTime={article.readingTime}
											link={"/article/" + article.slug}
										/>
									</div>
								))}
							</div>
						</div>

						<AboutBuilder context="Most of these pieces started as a problem I ran into at work, then became something worth writing down." />
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Articles;
